<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild
            :settings="fields.settings"
            :container-page="fields.containerPage"
            :show-container-page="false"
            :use-background-mobile="false"
            :show-background-image="false"
          />
        </div>

        <div class="mb-4">
          <label class="label-input">Image</label>
          <div class="group-item">
            <UploadImage
              :image="{ imageSrc: fields.image }"
              height="160"
              type-upload="image"
              @callback="handleUploadImage"
              @callbackDelete="handleRemoveImage"
            />
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'furnitureshop-carousel-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Furnitureshop carousel',
        enableAnchor: false,
        settings: {
          paddingTop: false,
          paddingBottom: false,
          backgroundColor: '#010101',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: false,
          backgroundImageMobile: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        image: '',
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) this.applyExtract(newVal.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopCarousel(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.image = (obj && obj.imageSrc) || '';
    },
    handleRemoveImage() {
      this.fields.image = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px !important;
  font-weight: 500;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
</style>
